<!--
 * @Description:商机
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-04 17:37:13
 * @LastEditors: cxh
-->
<template>
  <cos-table
    :columns="columns"
    @fetch="fetch"
    @mask="showMask"
    :tableId="tableIdByPath('business')"
    ref="tableRef"
    rowKey="id"
  >
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'saleChanceName'">
        <router-link :to="'/ofbu/business/view?id=' + record.id">
          <template v-if="record.arkCode">
            <template v-if="record.headDestinationCountryWarehouse">
              <p>{{ `${record.arkCode}+${getDemandInfoName(record.headDestinationCountryWarehouse)}` }}</p>
            </template>
            <template v-else><p>{{ record.arkCode }}</p></template>
          </template>
          <template v-else>
            <template v-if="record.headDestinationCountryWarehouse">
              <p>{{ getDemandInfoName(record.headDestinationCountryWarehouse) }}</p>
            </template>
            <template v-else>--</template>
          </template>
        </router-link>
      </template>
      <template v-if="column.dataIndex === 'status'">
        <dc-status :enums="statusEnum" :value="text" />
      </template>
      <template v-if="column.dataIndex === '$currency'">
        <p>{{ `${record.planSaleAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}` }}</p>
      </template>
      <template v-if="column.dataIndex === 'action'">
        <MoreButton>
          <SellerButton
            type="link"
            @click="handleEdit(record)"
            v-permission="permissionPage?.edit"
            >{{ t('btn.edit') }}</SellerButton
          >
          <a-button type="link" @click="handleDelete(record)" v-permission="permissionPage?.del">{{
            t('btn.del')
          }}</a-button>
        </MoreButton>
      </template>
    </template>
  </cos-table>
</template>
<script setup lang="ts">
import { ref, computed, reactive, onMounted } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/overseasSales/chanceManage'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'
import { useI18n } from 'vue-i18n'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import { useInteractionStore } from '@/stores/interaction'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const props = defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  arkCodeId: {
    type: String
  }
})
const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_currency: [], // 币种
  ofbu_demand_info: [], // 区域仓(需求海外仓参数)
  ofbu_shipments: [] // 发货量
})
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_currency', 'ofbu_demand_info', 'ofbu_shipments']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
/// 用来匹配商机名字的区域仓名
const getDemandInfoName = (headDestinationId?: number) => {
  const find = paramCodeData.ofbu_demand_info?.find((item) => item.id === headDestinationId)
  if (find) {
    return find[eumns[shareInfo.language]] ?? find.name
  }
  return headDestinationId || ''
}
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    businessList({
      arkCodeId: props.arkCodeId,
      saleChanceRefId: route.query.cosId as string,
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  } else {
    setTimeout(() => {
      callBack([])
    }, 500)
  }
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/ofbu/business/edit',
    query: {
      id: row.id,
      returnPath: route.fullPath
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success(t('business.bp7zke'))
        tableRef.value.delFetch()
      })
    }
  })
}
// 商机状态枚举
const statusEnum = computed(() => {
  const list = dataConfig.businessStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
  return list
})
const columns = computed(() => [
  { title: t('business.pehfv5'), dataIndex: 'saleChanceName', fixed: 'left', width: 200 },
  { title: t('business.nnrhea'), dataIndex: 'arkCode' },
  { title: t('common.contactName'), dataIndex: 'contactName', cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: 'contactMobile', cosType: 'mask' },
  { title: t('business.kolh0f'), dataIndex: 'currency', dicData: paramCodeData.ofbu_currency },
  { title: t('business.t3fsg4'), dataIndex: 'shipments', dicData: paramCodeData.ofbu_shipments },
  { title: t('business.me6p1g'), dataIndex: 'headDestinationCountryWarehouse', dicData: paramCodeData.ofbu_demand_info },
  { title: t('business.7xsihs'), dataIndex: 'status' },
  { title: t('custom.opportunityCreateTime'), dataIndex: 'createTime', width: 190 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right',
    langWidth: {
      zh: 100,
      en: 130
    }
  }
])
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default { name: 'tabsBusiness' }
</script>
